import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import { AutenticacaoService } from "../autenticacao/autenticacao.service";

@Component({
    selector: "app-login-token",
    template: ` <p>loading...</p> `,
    styles: [],
})
export class LoginTokenComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private autenticacaoService: AutenticacaoService,
    ) {
        const token = this.route.snapshot.paramMap.get("token");
        // Usa a sessão completa do serviço: gravar só o token deixava o access_token do aluno
        // anterior, que a validação renovava por cima do aluno deste link.
        this.autenticacaoService.setTokenSession(token ?? "");
        this.router.navigate(["tabs"]);
    }

    ngOnInit() {
    }
}
